





















import Vue from "vue";
import { isHTMLElement } from "../../utils/types";
type Data = {
  searchWord: string;
  optionList: string[];
  isOptionListShow: boolean;
};
export default Vue.extend({
  props: {
    type: String,
    placeholder: String,
    value: String
  },
  data(): Data {
    return {
      searchWord: this.value,
      optionList: ["g", "ml", "L", "cm", "個", "本"],
      isOptionListShow: false
    };
  },
  computed: {
    text: {
      get(): string {
        return this.value;
      },
      set(value: string): void {
        this.$emit("input", value);
      }
    }
    // optionsの数が少ないので、inputの値での絞り込みは一旦なし
    // filteredOptionList(): string[] | [] {
    //   if (!this.searchWord) return this.optionList;
    //   return this.optionList.filter(item => {
    //     return item.includes(this.searchWord);
    //   });
    // }
  },
  methods: {
    openOptionList(): void {
      this.isOptionListShow = true;
      const optionList = this.$refs.inputWithOption;
      if (!isHTMLElement(optionList)) return;
      this.$nextTick(() => optionList.focus());
    },
    closeOptionList(): void {
      this.isOptionListShow = false;
    },
    selectOption(option: string): void {
      this.$emit("input", option);
      this.closeOptionList();
    }
  }
});
